export const ALGOLIA_APP_ID = process.env.NEXT_PUBLIC_ALGOLIA_APP_ID!;
export const ALGOLIA_SEARCH_KEY = process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_KEY!;
export const WEBSITE_URL = process.env.NEXT_PUBLIC_WEBSITE_URL || "https://curiousprogrammer.dev";
export const STACK_PROJECT_ID = process.env.NEXT_PUBLIC_STACK_PROJECT_ID!;
export const STACK_PUBLISHABLE_CLIENT_KEY = process.env.NEXT_PUBLIC_STACK_PUBLISHABLE_CLIENT_KEY!;
export const IS_DEV = process.env.NEXT_ENVIRONMENT === "dev";
